'use client';

import React from 'react';
import OrdersHistory from 'components/commercetools-ui/organisms/account/sections/orders';

const AccountOrdersHistoryTastic = () => {
  return <OrdersHistory />;
};

export default AccountOrdersHistoryTastic;
